import {
  SET_IMAGE_ELEMENT_FILE_INFO,
  SET_IMAGE_ELEMENT_URL,
  SET_IMAGE_ELEMENT_WIDTH,
  SET_IMAGE_ELEMENT_HEIGHT,
  SET_IMAGE_ELEMENT_ALIGN,
} from './action-names';

export function setImageElementFileInfo(data) {
  return {
    type: SET_IMAGE_ELEMENT_FILE_INFO,
    ...data
  };
};

export function setImageElementURL(data) {
  return {
    type: SET_IMAGE_ELEMENT_URL,
    ...data
  };
};

export function setImageElementWidth(data) {
  return {
    type: SET_IMAGE_ELEMENT_WIDTH,
    ...data
  };
};

export function setImageElementHeight(data) {
  return {
    type: SET_IMAGE_ELEMENT_HEIGHT,
    ...data
  };
};

export function setImageElementAlign(data) {
  return {
    type: SET_IMAGE_ELEMENT_ALIGN,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/image-element-actions.js